import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', required, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-xs sm:text-sm font-medium text-neutral-700 mb-1.5">
            {label}
            {required && <span className="text-error-500 ml-1">*</span>}
          </label>
        )}
        <input
          ref={ref}
          className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white border rounded-xl shadow-sm transition-all duration-200 
          text-sm sm:text-base text-neutral-800 placeholder:text-neutral-400
          focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent
          disabled:bg-neutral-50 disabled:cursor-not-allowed disabled:text-neutral-400 ${
            error 
              ? 'border-error-300 focus:ring-error-500/30 bg-error-50/30' 
              : 'border-neutral-200 focus:ring-primary-500/30 hover:border-neutral-300'
          } ${className}`}
          {...props}
        />
        {error && <p className="mt-1.5 text-xs sm:text-sm text-error-500 flex items-center gap-1">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-xs sm:text-sm text-neutral-500">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
